import React from "react";
import { IoMdStar } from "react-icons/io";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../../../../utils";

const DetailItem = ({ data, handleHide }) => {
  const navigate = useNavigate();
  const handleBackToList = () => {
    navigate(`/bulletin-board`);
  };
  return (
    <div>
      <div>
        <h2 className="font-bold text-[14px]">상품 리뷰</h2>
        <div className="mt-[10px]">
          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="분류">
                <span className="p-2">
                  {data?.images?.length > 0
                    ? "상품 리뷰>포토 리뷰"
                    : "상품 리뷰>일반 리뷰"}
                </span>
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="등록 상태">
                <span
                  className={`p-2 ${
                    data?.visible === false ? "text-[#e80000]" : ""
                  }`}
                >
                  {data?.visible === true ? "정상 등록" : "숨김 상태"}
                </span>
              </FieldBox>
            </div>
          </div>

          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="평점">
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, index) => {
                    return (
                      <IoMdStar
                        key={index}
                        className={`text-lg ${
                          index + 1 < data?.rate + 1
                            ? "text-[#f2dca8]"
                            : "text-[#aaaaaa]"
                        }`}
                      />
                    );
                  })}
                </div>
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="등록일시 (숨김일시)">
                <span className="p-2">
                  {data?.createdAt ? formatDateTime(data?.createdAt) : "-"}
                  {data?.hiddenAt && ` (${formatDateTime(data?.hiddenAt)})`}
                </span>
              </FieldBox>
            </div>
          </div>

          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="작성자">
                <span className="p-2">
                  {data?.hospitalMember?.hospital?.name}{" "}
                  {`(${data?.hospitalMember?.email})`}
                </span>
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="리뷰 포인트">
                <span className="p-2">{data?.productGroup?.pointReview}P</span>
              </FieldBox>
            </div>
          </div>
          <FieldBox label="문의 내용">
            <div className="p-2 min-h-[100px]">{data?.contents}.</div>
          </FieldBox>
          <FieldBox label="사진">
            <div className="p-2 min-h-[100px] flex gap-2 items-center">
              {data?.images?.map((img, index) => (
                <Modal
                  key={`${index}-${img}`}
                  hasClose={true}
                  hasCancel={false}
                  hasSubmit={false}
                  padding="p-[10rem]"
                  description={
                    <img
                      src={img}
                      className="rounded-sm w-[400px] h-[400px] object-cover mx-auto"
                      alt="review-img"
                    />
                  }
                >
                  <img
                    src={img}
                    className="rounded-sm w-[100px] h-[100px] object-cover cursor-pointer"
                    alt="review-img"
                  />
                </Modal>
              ))}
            </div>
          </FieldBox>
          <FieldBox label="신고 횟수">
            <span className="p-2">BE PENDING</span>
          </FieldBox>
          <FieldBox isLast label="신고자">
            <span className="p-2">{data?.hospitalMember?.name}</span>
          </FieldBox>
        </div>
      </div>
      <div className="mt-[30px] flex justify-end">
        <Button
          width="w-24"
          onClick={handleBackToList}
          className="py-[8.5px]"
          text="목록"
        />
        <Modal
          description={
            data?.visible === true ? (
              <span>
                해당 리뷰에 대해, 리뷰를 '숨김' 하시겠습니까?
                <br />
                리뷰를 숨길 경우, '숨김 상태'로 변경되며 병원웹, 병원앱에서는
                비공개 처리 <br />
                됩니다.
              </span>
            ) : (
              <span>
                해당 리뷰에 대해, 리뷰를 '숨김 해제' 하시겠습니까?
                <br />
                리뷰를 숨김 해제할 경우, 비공개된 리뷰가 정상 등록되어
                공개됩니다.
              </span>
            )
          }
          maxWidth="max-w-[28rem]"
          bgSubmit="bg-[#a30000]"
          submitText={data?.visible === true ? "숨김" : "숨김 해제"}
          onSubmit={handleHide}
        >
          {data?.visible === true ? (
            <Button width="w-24" className="py-[8.5px]" text="숨김" />
          ) : (
            <Button
              width="w-24"
              className="py-[8.5px] text-white"
              bgColor="bg-[#a30000]"
              text="숨김 해제"
            />
          )}
        </Modal>
      </div>
    </div>
  );
};

export default DetailItem;
